import React from 'react';
import './contributeCard.css';
import HorizontalSlider from '../../components/HorizontalSlider';
import ContributorContributions from '../../components/ContributorContributions';
import { shuffle } from 'utils/';

function CardData() {
  const rtn = [];
  return rtn;
}
const ContributorCards = ({ contributors }) => {
  let displayCards = [];
  displayCards = shuffle(contributors);
  displayCards = contributors.map((contributor, i) => {
    return (
      <ContributorContributions
        key={'contributor' + i}
        name={contributor.displayName}
        img={contributor.profilePic ? contributor.profilePic.uri : ''}
        cuisines={contributor.cuisinesOfExpertise}
        followed={true}
        id={contributor.id}
      />
    );
  });
  return <HorizontalSlider>{displayCards}</HorizontalSlider>;
};

class Display extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentCard: 0,
      position: 0,
      cardStyles: {
        transform: 'translateX(0px)',
      },
      width: 0,
    };
  }
  // func: click the slider buttons
  handleClick(type) {
    // get the card's margin-right
    let margin = window.getComputedStyle(document.getElementById('contri-card'))
      .marginRight;
    margin = JSON.parse(margin.replace(/px/i, ''));
    const cardWidth = this.state.width; // the card's width
    const cardMargin = margin; // the card's margin
    const cardNumber = CardData().length; // the number of cards
    let currentCard = this.state.currentCard; // the index of the current card
    let position = this.state.position; // the position of the cards
    // slide cards
    if (type === 'next' && currentCard < cardNumber - 1) {
      currentCard++;
      position -= cardWidth + cardMargin;
    } else if (type === 'prev' && currentCard > 0) {
      currentCard--;
      position += cardWidth + cardMargin;
    }
    this.setCard(currentCard, position);
  }
  setCard(currentCard, position) {
    this.setState({
      currentCard: currentCard,
      position: position,
      cardStyles: {
        transform: `translateX(${position}px)`,
      },
    });
  }
  render() {
    const { contributors } = this.props;
    return (
      <div className="cards-slider1" id="contri-card">
        <div className="slider-btns1">
          <button
            className="slider-btn btn-l1"
            onClick={() => this.handleClick('prev')}
          >
            <svg
              className="icon1"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path d="M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z" />
            </svg>{' '}
          </button>
          <button
            className="slider-btn btn-r1"
            onClick={() => this.handleClick('next')}
          >
            {' '}
            <svg
              className="icon1"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" />
            </svg>{' '}
          </button>
        </div>
        <ContributorCards contributors={contributors} />
      </div>
    );
  }
}

export default Display;
